// extracted by mini-css-extract-plugin
export var copyableField = "_js-4";
export var customerBadge = "_js-0";
export var customerInfoTitle = "_js-2";
export var details = "_js-1";
export var dropdownContainer = "_js-5";
export var dropdownImage = "_js-6";
export var editAssigneeForm = "_js-a";
export var editButton = "_js-3";
export var email = "_js-7";
export var hidden = "_js-d";
export var input = "_js-8";
export var saveButton = "_js-b";
export var shopifyIcon = "_js-c";
export var suggestionBadge = "_js-e";
export var suggestionText = "_js-f";
export var username = "_js-9";